module.exports = __webpack_public_path__ + "img/selected4-min.8bdb4d1b.png";